// NPTA – Recharge dynamic overrides
(function () {
  function log() {
    console.log('[NPTA Recharge]', ...arguments);
  }

  function getPlanConfig(widget) {
    const root = widget.shadowRoot;
    if (!root) return null;

    const sellingEl = root.querySelector('rc-selling-plans');
    if (!sellingEl || !sellingEl.shadowRoot) return null;

    const sellingRoot = sellingEl.shadowRoot;
    const spans = sellingRoot.querySelectorAll(
      'span[part~="rc-plans-button__interval"]'
    );

    const planCount = spans.length;
    if (!planCount) return null;

    const monthMap = [3, 6, 9];
    const months = monthMap.slice(0, planCount);

    const targetTexts = months.map((m) => `${m} months to pay`);

    let benefitsText = '';
    if (months.length === 1) {
      benefitsText = `${months[0]} months`;
    } else if (months.length === 2) {
      benefitsText = `${months[0]} and ${months[1]} months`;
    } else if (months.length === 3) {
      benefitsText = `${months[0]}, ${months[1]}, and ${months[2]} months`;
    }

    return {
      planCount,
      months,
      targetTexts,
      benefitsText,
      sellingRoot,
      spans
    };
  }

  function overrideBenefits(widget) {
    const root = widget.shadowRoot;
    if (!root) return false;

    const config = getPlanConfig(widget);
    if (!config) return false;

    const benefitsEl = root.querySelector('rc-benefits');
    if (!benefitsEl || !benefitsEl.shadowRoot) return false;

    const benefitsRoot = benefitsEl.shadowRoot;

    // Get the first <li> then the first <strong> inside it
    const firstLi = benefitsRoot.querySelector('li');
    if (!firstLi) return false;

    const strongEl = firstLi.querySelector('strong');
    if (!strongEl) return false;

    const current = (strongEl.textContent || '').trim();
    const next = config.benefitsText;

    if (current !== next) {
      strongEl.textContent = next;
      log('Updated benefits copy to:', next);
      return true;
    }

    return true;
  }

  function overridePlans(widget) {
    const config = getPlanConfig(widget);
    if (!config) return false;

    config.spans.forEach((span, idx) => {
      const labelText = config.targetTexts[idx];
      if (!labelText) return;

      span.textContent = labelText;

      const label = span.closest('label');
      if (label) {
        const input = label.querySelector('input[name="rc_plan"]');
        if (input) {
          input.setAttribute('aria-label', labelText);
        }
      }
    });

    log('Updated plan buttons to:', config.targetTexts.join(' / '));
    return true;
  }

  function applyOverrides(widget) {
    const ok1 = overrideBenefits(widget);
    const ok2 = overridePlans(widget);
    return ok1 || ok2;
  }

  function runBurst(widget, reason) {
    log(
      'Running override burst:',
      reason,
      'for product',
      widget.getAttribute('product-id')
    );

    let attempts = 0;
    const burstId = setInterval(function () {
      attempts += 1;
      applyOverrides(widget);

      if (attempts >= 20) {
        clearInterval(burstId);
        log('Finished burst for', widget.getAttribute('product-id'));
      }
    }, 150);
  }

  function setupToggleListeners(widget) {
    if (widget.__nptaListenersAttached) return;

    const root = widget.shadowRoot;
    if (!root) return;

    const purchaseInputs = root.querySelectorAll('input[name="purchaseOption"]');
    if (!purchaseInputs.length) return;

    purchaseInputs.forEach((input) => {
      input.addEventListener('change', function () {
        runBurst(widget, 'purchaseOption change');
      });
    });

    widget.__nptaListenersAttached = true;
    log(
      'Attached purchaseOption change listeners for product',
      widget.getAttribute('product-id')
    );
  }

  function setupWidget(widget) {
    if (widget.__nptaSetup) return;
    widget.__nptaSetup = true;

    runBurst(widget, 'initial load');

    let tries = 0;
    const listenerInterval = setInterval(function () {
      setupToggleListeners(widget);
      tries += 1;
      if (widget.__nptaListenersAttached || tries >= 20) {
        clearInterval(listenerInterval);
      }
    }, 200);
  }

  function scanWidgets() {
    const widgets = document.querySelectorAll('recharge-subscription-widget');
    widgets.forEach(setupWidget);
  }

  function init() {
    scanWidgets();

    const pageObserver = new MutationObserver(function () {
      scanWidgets();
    });

    pageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();